import * as api from '@owl-nest/api-client/next'
import * as date from '@owl-nest/date'
import { t } from '@owl-nest/localize'

export function projectFans(
  project: api.Project,
  onSuccessMessage: () => void,
  onFailureMessage: () => void,
): () => Promise<void> {
  return async (): Promise<void> => {
    if (project === undefined) {
      return
    }

    const dateStart = date
      .createDateWithTimezone(project.date_start ?? new Date().toISOString(), project.timezone)
      .toISOString()
    const dateEnd = date.createDateWithTimezone(new Date().toISOString(), project.timezone).toISOString()

    const payload: api.CreateExport = {
      date_end: date.format(new Date(dateEnd), 'yyyy-MM-dd'),
      date_start: date.format(new Date(dateStart), 'yyyy-MM-dd'),
      tabulars: {
        format: 'csv',
        exports: getExports(),
      },
    }

    const result = await projectData(String(project.id), payload)

    result.caseOf({
      left: onFailureMessage,
      right: (exportResponse) => {
        if (exportResponse.status === 'processing' || exportResponse.status === 'waiting') {
          onSuccessMessage()
        } else if (
          exportResponse.status === 'succeeded' &&
          (exportResponse.url !== undefined || exportResponse.url !== null)
        ) {
          window.open(exportResponse.url, '_blank')
        }
      },
    })
  }

  function getExports(): api.ExportTabularStructure[] {
    return [
      {
        sheets: [
          {
            view_type: 'view_by_fans',
            sheet_name: t('pre-registered-fans-list'),
            columns: {
              'user.email': t('Email'),
              created_at: t('Creation date'),
              fan_type: t('Type'),
            },
          },
        ],
        type: 'project_fans',
      },
    ]
  }
}

export async function projectData(
  slug: string | number,
  payload: api.CreateExport,
): Promise<api.HttpResult<api.Export>> {
  const response = await api.client('POST /projects/:id/exports', {
    body: payload,
    urlParams: { id: String(slug) },
  })

  return response.next((success) => success.body)
}
